export const PA_SAVE_PRESCRIBER_CROSSWALK = 'paSavePrescriberCrosswalk';
export const PA_SEARCH_PRESCRIBER_CROSSWALK = 'paSearchPrescriberCrosswalk';
export const PA_GET_PRESCRIBER_CROSSWALK = 'paGetPrescriberCrosswalk';
export const PA_DELETE_PRESCRIBER_CROSSWALK = 'paDeletePrescriberCrosswalk';



// WEBPACK FOOTER //
// ./src/store/prescriber-crosswalk/actions.type.js